import { render, staticRenderFns } from "./LockTicket.vue?vue&type=template&id=a34212a4&scoped=true&"
import script from "./LockTicket.vue?vue&type=script&lang=js&"
export * from "./LockTicket.vue?vue&type=script&lang=js&"
import style0 from "./LockTicket.vue?vue&type=style&index=0&id=a34212a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34212a4",
  null
  
)

export default component.exports